module.exports = " <div> <app-header></app-header> <div class=site-content> <router-view></router-view> <app-footer></app-footer> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/App.vue
// module id = 478
// module chunks = 1